<template>
  <Loader :value="promises.fetch" class="settings-tokens-loader">
    <Paywall
      :value="$store.getters.isSuperadmin ? [false] : $store.state.addons"
      :items="$store.getters.isSuperadmin ? [false] : 'api'"
    >
      <template #content>
        <Pricing value="api">
          <template #actions>
            <ButtonComponent
              :label="$t('activate')"
              :icon="['fal', 'plus']"
              theme="primary"
              :labels="{ confirm: $t('confirm') }"
              :icons="{ confirm: ['fas', 'question-circle'] }"
              confirm
              @click="addon"
              :promise="addonPromise"
            />
          </template>
        </Pricing>
      </template>
      <template #default>
        <Card class="settings-tokens">
          <template #default>
            <DataTable
              :value="items"
              :columns="[{ id: 'name', label: $t('name') }]"
              theme="border"
              :row-wrapper="
                item => ({
                  component: 'router-link',
                  props: {
                    to: { name: 'token-edit', params: { id: item.id } },
                    style: 'color: inherit',
                  },
                })
              "
            >
              <template #name="{ item }">
                <span>{{ item.name }}</span>
                <FontAwesomeIcon v-if="item.isSystem" :icon="['fal', 'cog']" size="sm" class="ml-1" />
              </template>
              <template #primary-row-actions="{ item }">
                <ButtonComponent
                  tag="router-link"
                  :to="{ name: 'token-edit', params: { id: item.id } }"
                  v-tooltip="$t('edit')"
                  :icon="['fal', 'pen']"
                />
              </template>
            </DataTable>
            <EmptyState
              v-if="!items.length"
              :icon="['fal', 'key']"
              :title="$t('noX', { x: $tc('token', 2).toLowerCase() })"
            />
          </template>
          <template #footer>
            <ButtonComponent
              tag="router-link"
              :to="{ name: 'token-create' }"
              :label="$t('create')"
              :icon="['fal', 'plus']"
              theme="primary"
            />
          </template>
        </Card>
      </template>
    </Paywall>
  </Loader>
</template>

<script>
import { i18n } from '@/i18n'
import Store from '@/store'
import { mapState, mapActions } from 'vuex'

import Card from '@/components/Card'
import { Paywall } from '@/components/Upsell'
import Pricing from '@/components/Pricing'
import DataTable from '@/components/DataTable'
import EmptyState from '@/components/EmptyState'

const meta = {
  skip: !Store.getters.isDeveloper,
  order: 2,
  id: 'tokens',
  label: i18n.tc('token', 2),
  icon: ['fal', 'redo'],
}

export { meta }
export default {
  props: {
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler(val) {
        if (!val) return
        return this.fetch()
      },
      immediate: true,
    },
  },
  data() {
    return {
      addonPromise: null,
    }
  },
  computed: {
    ...mapState('Token', ['items', 'promises']),
  },
  methods: {
    ...mapActions('Token', ['fetch']),
    addon() {
      return (this.addonPromise = this.$store.dispatch('subscription', { item: 'api', state: true }))
    },
  },
  components: {
    Card,
    Paywall,
    Pricing,
    DataTable,
    EmptyState,
  },
}
</script>
